<template>
    <Dropdown
        v-if="actions"
        :options="actions"
        @onClick="handleClickOption"
    >
        <WButton
            iconLeft="refresh-cw"
            outline
            color="accent-blue"
            :disabled="isLoading"
            :loading="isLoading"
        >
            {{ $t('entities.reloadEntities') }}
        </WButton>
    </Dropdown>
</template>

<script>
import {
    Api, apiRequest, rethrowError, notifySuccess, notifyError,
} from '@/api'
import { Dropdown } from '@/components'

export default {
    name: 'Reload',
    components: {
        Dropdown,
    },
    data () {
        const ACTIONS = [
            {
                icon: 'refresh-cw',
                key: 'computed',
                label: this.$t('entities.reload.options.computed'),
            },
            {
                icon: 'refresh-cw',
                key: 'preqin',
                label: this.$t('entities.reload.options.preqin'),
            },
            {
                icon: 'refresh-cw',
                key: 'qreports',
                label: this.$t('entities.reload.options.qreports'),
            },
        ]

        return {
            actions: ACTIONS,
            isLoading: false,
        }
    },
    methods: {
        handleClickOption ({ key }) {
            this.handleReload(key)
        },
        handleReload (source) {
            this.isLoading = true
            apiRequest(Api().imports.create({ source }))
                .then(() => notifySuccess(this.$t(`entities.reload.notifications.${source}`))())
                .catch(rethrowError(notifyError()))
                .finally(() => (this.isLoading = false))
        },
    },
}
</script>
